import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const NAV = [
  { label: "Soluções", to: "/#solucoes", id: "solucoes" },
  { label: "Segurança", to: "/#seguranca", id: "seguranca" },
  { label: "Sobre", to: "/sobre", id: "sobre" },
  { label: "Termos", to: "/termos", id: "termos" },
  { label: "Privacidade", to: "/privacidade", id: "privacidade" },
];

export function Header() {
  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
        <div className="flex items-center gap-4">
          <Logo testId="header-logo-link" />
          <span
            data-testid="header-indicator"
            className="border-l border-slate-800 pl-4 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400 sm:text-[11px]"
          >
            Tecnologia em Protocolos Extrajudiciais
          </span>
        </div>
        <nav aria-label="Navegação principal" className="-mx-1 flex gap-1 overflow-x-auto">
          {NAV.map((item) => (
            <Link
              key={item.id}
              to={item.to}
              data-testid={`header-nav-${item.id}`}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-slate-300 transition-colors duration-200 hover:bg-slate-900 hover:text-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
